"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendPingback = void 0;
var js_util_1 = require("@giphy/js-util");
// TODO remove api key
var pingBackUrl = 'https://pingback.giphy.com/pingback?apikey=l0HlIwPWyBBUDAUgM';
exports.sendPingback = function (session) {
    var headers = js_util_1.getGiphySDKRequestHeaders();
    headers === null || headers === void 0 ? void 0 : headers.set('Content-Type', 'application/json');
    js_util_1.Logger.debug("Pingback session", session);
    return fetch(pingBackUrl, {
        method: 'POST',
        body: JSON.stringify({ sessions: [session] }),
        headers: headers,
    });
};
//# sourceMappingURL=send-pingback.js.map